<template>
	<LoadOnScroll @loadMore="loadMoreMessages" class="message-list">
		<ul
			v-if="messages.data.length"
			class="message-list__list"
		>
			<li
				class="message"
				v-for="( message, index ) in messages.data"
				:key="index"
				:class="{
					'message--active' : selectedIndex === index,
					'message--unread': !message.seen && activeTab !== 'sent'
				}"
				@click="selectMessage(index, message)"
			>
				<MessageHeader
					:sender="message.name"
					:sender-email="message.email"
					:message-date="message.date_created"
					:message-time="message.time_created"
					:avatar="message.image"
				>
				</MessageHeader>

				<div class="message__content">
					<h3 class="message__subject">{{ message.type || message.subject }}</h3>
					<p>
					{{ message.content || message.message | null | stripHtmlTag | summarize(50) }}
					</p>
				</div>
			</li>
		</ul>

		<p
			v-if="!messages.data.length && !messagesLoading"
			class="message-list__empty"
		>
			No Message Found
		</p>

		<div
			v-if="messagesLoading"
			class="message-list__loading"
			:class="{'message-list__loading--initial' : !messages.data.length}"
		>
			<AppLoading/>
		</div>
	</LoadOnScroll>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import MessageHeader from '@/components/messages/MessageHeader.vue'
import LoadOnScroll from '@/components/layouts/LoadOnScroll.vue'

export default {
	props: ['activeTab'],

	computed: {
		...mapFields('message', {
			messagesLoading: 'messagesLoading',
			selectedIndex: 'selectedIndex',
			selectedMessage: 'selectedMessage',
			messages: 'messages'
		})
	},

	methods: {
		async selectMessage (value, message) {
			if (!message.seen && this.activeTab !== 'sent') {
				const form = new FormData()
				form.append('id', message.id)
				form.append('seen', 1)

				await this.$store.dispatch('message/seenMessage', { form, message })
				this.$store.dispatch('message/getCount')
			}
			this.selectedIndex = value
			this.selectedMessage = this.messages.data[value]
		},

		loadMoreMessages () {
			const { current_page, last_page } = this.messages
			if (current_page === last_page || this.messagesLoading) return
			this.$emit('loadMore')
		}
	},

	components: {
		MessageHeader,
		LoadOnScroll
	}
}
</script>

<style lang="scss" scoped>
.message-list {
    overflow-x: hidden;
    overflow-y: scroll;
	background-color: #fff;
	border: .5px solid lighten($default-light, 12%);
	position: relative;
	font-size: 12px;
	padding-bottom: 50px;

	&__list {
		.message {
			border-bottom: 1px solid  lighten($default-light, 12%);
			padding: 20px;
			cursor: pointer;
			transition: 0.3s;
			background-color: #fff;

			// &--active, &:hover {
			// 	background-color: $primary-light;
			// }

			&--unread {
				background-color: #64728717;
			}

			&__content {
				padding-left: 3.5em;
			}

			&__subject {
				font-size: 1em;
				font-weight: bold;
				margin: 1em 0;
				text-transform: capitalize;
			}
		}
	}

	&__empty, &__loading {
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		width: 100%;
	}

	&__empty {
		font-size: 1em;
		color: $default-light;
		height: 100%;
	}

	&__loading {
		padding: 20px 0;
		&--initial { height: 100%; }
	}
}
</style>
